import React, { useEffect, useState } from "react";
import "./published-plan-objective-accordion.scss";
import { PublishedPlanObjectiveAccordionItem } from "./PublishedPlanObjectiveAccordionItem";
import { useDispatch } from "react-redux";

export const PublishedPlanObjectiveAccordion = ({
  objectives,
  callBack,
  businessPlanId,
  expandedObjective,
  isViewMode,
  expandedKeyResult,
  isPlanPublished,
  allowDelete,
  closeAllAccordions,
  showActions,
}) => {
  const dispatch = useDispatch();
  const [buttonDisabled, setButtonDisabled] = useState(false);
  const [expandedItems, setExpandedItems] = useState([]);
  const [showDeleteObjectivePopup, setShowDeleteObjectivePopup] = useState({
    show: false,
  });
  const [showConfirmationButtons, setShowConfirmationButtons] = useState({
    show: false,
    type: "",
  });

  useEffect(() => {
    if (closeAllAccordions) {
      setExpandedItems([]);
    }
  }, [closeAllAccordions]);

  const handleAccordionToggle = (index) => {
    setExpandedItems((prevExpandedItems) => {
      if (prevExpandedItems.includes(index)) {
        return prevExpandedItems.filter((item) => item !== index);
      } else {
        return [...prevExpandedItems, index];
      }
    });
  };
  
  return (
    <div className="px-3" id="published-plan-objective-accordion">
      {objectives.map((objective, index) => {
        return (
          <PublishedPlanObjectiveAccordionItem
            key={objective.businessPlanObjectiveId}
            objective={objective}
            isLastObjective={!allowDelete}
            callBack={callBack}
            isViewMode={isViewMode}
            isPlanPublished={isPlanPublished}
            buttonDisabled={buttonDisabled}
            showDeleteObjectivePopup={showDeleteObjectivePopup}
            setShowDeleteObjectivePopup={setShowDeleteObjectivePopup}
            isExpanded={expandedItems.includes(index)}
            onHeaderClick={() => {
              setShowConfirmationButtons({ show: false, type: "" });
              handleAccordionToggle(index);
            }}            
            businessPlanId={businessPlanId}
            showConfirmationButtons={showConfirmationButtons}
            setShowConfirmationButtons={setShowConfirmationButtons}
            closeAllAccordions={closeAllAccordions}
            showActions={showActions}
          />
        );
      })}      
    </div>
  );
};
